export default class Browser {
    constructor(Rest) {
        this.rest = Rest.rest;    
    }
    
    createPreferences(settings, font, url) {
        return this.rest.all('browser/preferences').post({ settings: settings, font: font, url: url });
    };

    updatePreferences(settings) {
        return this.rest.all('browser/updatePreferences').customPUT(settings);
    }

    getPreferences(url) {
        return this.rest.one('browser', url).one('preferences').get();
    }

    updateField(groupId, id, data) {
        return this.rest.one('customization').one('group', groupId).one('field', id).put(data);
    };
};
